import moment from 'moment';
import { BLANK_IMAGE_URL, UPLOADING_IMAGE_URL } from '../define/consts/assets';
export const newWindow = (url) => {
    const win = window.open(url, '_blank');
    win.focus();
};
const css3FilterFeatureDetect = (enableWebkit) => {
    let checkWebkit = enableWebkit;
    // As I mentioned in my comments, the only render engine which truly supports
    // CSS3 filter is webkit. so here we fill webkit detection arg with its default
    if (enableWebkit === undefined) {
        checkWebkit = false;
    }
    // creating an element dynamically
    const el = document.createElement('div');
    // adding filter-blur property to it
    el.style.cssText = `${checkWebkit ? '-webkit-' : ''}filter: blur(2px)`;
    // checking whether the style is computed or ignored
    // And this is not because I don't understand the !! operator
    // This is because !! is so obscure for learning purposes! :D
    const test1 = el.style.length !== 0;
    // checking for false positives of IE
    // I prefer Modernizr's smart method of browser detection
    const test2 = document.documentMode === undefined || // non-IE browsers, including ancient IEs
        document.documentMode > 9; // IE compatibility moe
    // combining test results
    return test1 && test2;
};
/**
 * filterが使えるかどうか
 * @type {boolean}
 */
export const isSupportFilter = css3FilterFeatureDetect() || css3FilterFeatureDetect(true);
/**
 * 一時封印用
 * @type {boolean}
 */
export const isDisable = false;
/**
 * empty function
 * @returns {null}
 */
export const emptyFunc = () => null;
/**
 * 一定時間の待機
 * @param waitSeconds
 * @returns {Promise<any>}
 */
export const sleep = (waitSeconds) => new Promise((resolve) => {
    setTimeout(() => resolve(), waitSeconds * 1000);
});
/**
 * 日付を表示用の文字列に変換して取得
 * @param value
 * @returns {string}
 */
export const getViewYmd = (value) => {
    if (value) {
        return moment(value, 'YYYY-MM-DD').format('YYYY.MM.DD');
    }
    return '';
};
/**
 * 現在の日時を文字列で返す
 * @param format
 * @returns {string}
 */
export const getCurrentDatetimeString = (format = 'YYYY-MM-DD HH:mm:ss') => moment().format(format);
/**
 * 指定の日時を文字列で返す
 * @param value
 * @param format
 * @returns {string}
 */
export const getFormatDatetimeString = (value, format = 'YYYY-MM-DD HH:mm:ss') => moment(value).format(format);
/**
 * 配列から指定の値を検索し、その部分を削除する
 * @param list
 * @param condition
 * @returns {[]}
 */
export const deleteListItem = (list, condition) => {
    const index = list.findIndex((v) => {
        if (typeof condition === 'object') {
            return Object.keys(condition).every((k) => v[k] === condition[k]);
        }
        return v === condition;
    });
    if (index >= 0) {
        list.splice(index, 1);
        return [...list];
    }
    return list;
};
/**
 * 配列から指定の値を検索し、その値を更新する
 * @param list
 * @param condition
 * @param item
 * @param isMerge
 * @returns {*[]|*}
 */
export const updateListItem = (list, condition, item, isMerge = false) => {
    const index = list.findIndex((v) => {
        if (typeof condition === 'object') {
            return Object.keys(condition).every((k) => v[k] === condition[k]);
        }
        return v === condition;
    });
    if (index >= 0) {
        const newItems = [...list];
        if (isMerge) {
            newItems[index] = Object.assign(Object.assign({}, newItems[index]), item);
        }
        else {
            newItems[index] = Object.assign({}, item);
        }
        return newItems;
    }
    return list;
};
/**
 * null,undefinedなど空データかどうかのチェック
 * @param value
 * @returns {boolean}
 */
export const isEmpty = (value) => {
    if (value === undefined || value === null || Number.isNaN(value)) {
        return true;
    }
    if (Array.isArray(value)) {
        return value.length === 0 || value.every((v) => v === false);
    }
    if (typeof value === 'object') {
        return false;
    }
    return String(value).length === 0;
};
/**
 * field用に文字列を数値に変換する
 * @param anyValue
 * @returns {string|*}
 */
export const fieldFormatNumber = (anyValue) => {
    if (isEmpty(anyValue)) {
        return anyValue;
    }
    const intValue = parseInt(anyValue, 10);
    if (Number.isNaN(intValue)) {
        return '0';
    }
    return String(intValue);
};
/**
 * propagationのstop
 * @param e
 */
export const stopPropagation = (e) => e.stopPropagation();
/**
 * transition on/offで再計算が走るようにするfunction
 * @param node
 * @return {number}
 */
export const reDraw = (node) => node.offsetHeight;
/**
 * 定数candidatesからのvalueでの検索とlabelの取得
 * @deprecated TS化済 src/utils/array/find.ts
 * @param list
 * @param value
 * @returns {*|string}
 */
export const findCandidatesLabel = (list, value) => {
    const intValue = parseInt(value, 10);
    return (list.find((v) => v.value === intValue) || {}).label || '';
};
/**
 * block表示のstyle
 * @type {{display: string}}
 */
export const blockStyle = { display: 'block' };
/**
 * 非表示のstyle
 * @type {{display: string}}
 */
export const noneStyle = { display: 'none' };
/**
 * 背景画像指定用のstyleの取得
 * @param image
 * @returns {{backgroundImage: string}}
 */
export const makeBgImage = (image) => ({
    backgroundImage: `url(${image || BLANK_IMAGE_URL})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
});
/**
 * null, undefined, emptyのチェック
 * @deprecated TS化済 src/utils/checkValue/string.ts
 * @param str
 * @returns {boolean}
 */
export const isNullOrUndefinedOrEmpty = (str) => str === null || str === undefined || str === '';
export const judgeUploadingImage = (id, imagePath) => {
    if (!isNullOrUndefinedOrEmpty(id) && !imagePath) {
        return UPLOADING_IMAGE_URL;
    }
    return imagePath;
};
